/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationMoveReqVo
 */
export interface AdminStockAdjustLocationMoveReqVo {
    /**
     * 会员ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    userId: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    warehouseId: number;
    /**
     * 来源箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    sourceBoxId: number;
    /**
     * 商品批次 goodsId
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    goodsId: number;
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    skuId: number;
    /**
     * 移箱数量
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    quantity: number;
    /**
     * 目标存储方式：0 装箱保管 1 单独保管
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    separateStore: number;
    /**
     * 目标箱ID（装箱保管必填）
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    targetBoxId?: number;
    /**
     * 纸箱计费物料ID（单独保管必填）
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    materialId?: number;
    /**
     * 单独保管新建箱·长(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    length?: number;
    /**
     * 单独保管新建箱·宽(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    width?: number;
    /**
     * 单独保管新建箱·高(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveReqVo
     */
    height?: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationMoveReqVo interface.
 */
export function instanceOfAdminStockAdjustLocationMoveReqVo(value: object): value is AdminStockAdjustLocationMoveReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('sourceBoxId' in value) || value['sourceBoxId'] === undefined) return false;
    if (!('goodsId' in value) || value['goodsId'] === undefined) return false;
    if (!('skuId' in value) || value['skuId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('separateStore' in value) || value['separateStore'] === undefined) return false;
    return true;
}

export function AdminStockAdjustLocationMoveReqVoFromJSON(json: any): AdminStockAdjustLocationMoveReqVo {
    return AdminStockAdjustLocationMoveReqVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationMoveReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'warehouseId': json['warehouseId'],
        'sourceBoxId': json['sourceBoxId'],
        'goodsId': json['goodsId'],
        'skuId': json['skuId'],
        'quantity': json['quantity'],
        'separateStore': json['separateStore'],
        'targetBoxId': json['targetBoxId'] == null ? undefined : json['targetBoxId'],
        'materialId': json['materialId'] == null ? undefined : json['materialId'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
    };
}

export function AdminStockAdjustLocationMoveReqVoToJSON(json: any): AdminStockAdjustLocationMoveReqVo {
    return AdminStockAdjustLocationMoveReqVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveReqVoToJSONTyped(value?: AdminStockAdjustLocationMoveReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'sourceBoxId': value['sourceBoxId'],
        'goodsId': value['goodsId'],
        'skuId': value['skuId'],
        'quantity': value['quantity'],
        'separateStore': value['separateStore'],
        'targetBoxId': value['targetBoxId'],
        'materialId': value['materialId'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
    };
}

